import { useEffect, useState } from "react";
import "./Hero.css";

const slides = [
  {
    tag: "Advanced Dental Care",
    title: "Your Smile,\nOur Passion",
    subtitle: "Experience world-class dental care with cutting-edge technology and a compassionate team dedicated to your comfort.",
    cta: "Book Appointment",
    cta2: "Meet Our Doctor",
  },
  {
    tag: "Dental Implants",
    title: "Restore Your\nPerfect Smile",
    subtitle: "State-of-the-art implant solutions that look, feel, and function just like your natural teeth. Life-changing results.",
    cta: "Explore Implants",
    cta2: "View Services",
  },
  {
    tag: "Cosmetic Dentistry",
    title: "Transform Your\nConfidence",
    subtitle: "From teeth whitening to complete smile makeovers — discover the art and science behind a truly beautiful smile.",
    cta: "Get Started",
    cta2: "Our Services",
  },
];

const stats = [
  { value: "Qualified Dental Surgeon", label: "" },
  { value: "500+", label: "Happy Patients" },
  { value: "98%", label: "Success Rate" },
  { value: "20+", label: "Services Offered" },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((c) => (c + 1) % slides.length);
        setAnimating(false);
      }, 400);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (i) => {
    if (i === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(i);
      setAnimating(false);
    }, 400);
  };

  const slide = slides[current];

  return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <div className="hero-orb hero-orb-1"></div>
        <div className="hero-orb hero-orb-2"></div>
        <div className="hero-grid"></div>
      </div>

      <div className="hero-inner">
        <div className={`hero-content ${animating ? "fade-out" : "fade-in"}`}>
          <span className="hero-tag">{slide.tag}</span>
          <h1 className="hero-title">
            {slide.title.split("\n").map((line, i) => (
              <span key={i}>{line}{i === 0 && <br />}</span>
            ))}
          </h1>
          <p className="hero-subtitle">{slide.subtitle}</p>
          <div className="hero-actions">
            <a href="#contact" className="btn-primary hero-btn-main">
              {slide.cta}
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="#about" className="hero-btn-ghost">{slide.cta2}</a>
          </div>

          <div className="hero-stats">
            {stats.map((s) => (
              <div key={s.label} className="hero-stat">
                <span className="hero-stat-value">{s.value}</span>
                <span className="hero-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-card-float">
            <div className="float-card card-1">
              <div className="float-icon">✓</div>
              <div>
                <div className="float-label">Certified Specialists</div>
                <div className="float-sub">MDS Qualified</div>
              </div>
            </div>
            <div className="float-card card-2">
              <div className="float-icon">★</div>
              <div>
                <div className="float-label">4.5+ / 5 Rating</div>
                <div className="float-sub">250+ Reviews</div>
              </div>
            </div>
            <div className="tooth-visual">
              <svg viewBox="0 0 200 220" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="toothGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#e8f7f5"/>
                    <stop offset="100%" stopColor="#b2e4dc"/>
                  </linearGradient>
                  <linearGradient id="toothShine" x1="0" y1="0" x2="0.5" y2="1">
                    <stop offset="0%" stopColor="white" stopOpacity="0.8"/>
                    <stop offset="100%" stopColor="white" stopOpacity="0"/>
                  </linearGradient>
                </defs>
                <path d="M100 20 C60 20 35 45 35 75 C35 95 42 115 48 135 C54 155 58 185 70 195 C78 202 88 198 95 185 C98 178 100 168 100 168 C100 168 102 178 105 185 C112 198 122 202 130 195 C142 185 146 155 152 135 C158 115 165 95 165 75 C165 45 140 20 100 20Z" fill="url(#toothGrad)" stroke="#0a7c6e" strokeWidth="2.5"/>
                <path d="M72 20 C72 20 65 40 65 60 C65 70 68 78 72 78" stroke="#0a7c6e" strokeWidth="1.5" strokeOpacity="0.3" fill="none"/>
                <path d="M128 20 C128 20 135 40 135 60 C135 70 132 78 128 78" stroke="#0a7c6e" strokeWidth="1.5" strokeOpacity="0.3" fill="none"/>
                <ellipse cx="88" cy="50" rx="14" ry="8" fill="url(#toothShine)"/>
                <circle cx="60" cy="80" r="6" fill="#0a7c6e" fillOpacity="0.15"/>
                <circle cx="140" cy="80" r="6" fill="#0a7c6e" fillOpacity="0.15"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-controls">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`hero-dot ${i === current ? "active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      <a href="#about" className="hero-scroll-hint">
        <div className="scroll-line"></div>
        <span>Scroll</span>
      </a>
    </section>
  );
}
